import { put, call, takeEvery } from 'redux-saga/effects';
import { axiosInstance, apiURL } from 'config';
import toast from 'react-hot-toast';

import {
  loadOffersRequested,
  loadOffersSuccess,
  loadOffersFail,
  storeOfferRequested,
  storeOfferSuccess,
  storeOfferFail,
  loadNonPaginatedOfferRequested,
  loadNonPaginatedOfferSuccess,
  loadNonPaginatedOfferFail,
  updateOfferRequested,
  updateOfferSuccess,
  updateOfferFail,
  deleteOfferRequested,
  deleteOfferSuccess,
  deleteOfferFail,
  storeAssignProductRequested,
  storeAssignProductSuccess,
  storeAssignProductFail,
  removeOfferRequested,
  removeOfferSuccess,
  removeOfferFail,
} from './offersSlice';
import { loadProductEffect } from 'store/products/sagas';

export function* loadOffersEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/index-offers?searchString=${
        action?.payload?.filters?.query ?? ''
      }&page=${action.payload.page}&pageSize=${action.payload.perPage}`,
      action.payload
    );

    yield put(loadOffersSuccess(data));
  } catch (error: any) {
    yield put(loadOffersFail(error.message));
  }
}

export function* loadNonPaginatedOffersEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-list-of-offers`
    );

    yield put(loadNonPaginatedOfferSuccess(data));
  } catch (error: any) {
    yield put(loadNonPaginatedOfferFail(error.message));
  }
}

export function* deleteOfferEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/delete-offer?Id=${action.payload?.item?.id}`,
      action.payload
    );

    if (data?.succeeded) {
      yield put(deleteOfferSuccess(data));

      toast.success('Offers deleted successfully');
    } else {
      toast.error('Offers delete failed!', data?.errors);
    }
  } catch (error: any) {
    yield put(deleteOfferFail(error.message));
  }
}

export function* storeOfferEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/create-offer`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(storeOfferSuccess(data));

      if (data?.succeeded) {
        yield call(storeAssignProductEffect, {
          payload: {
            offerId: data?.result,
            itemId: action?.payload?.productId,
            isLanding: true,
            isActive: true,
          },
          type: '',
        });
      }
      toast.success('Offer created successfully');
    } else {
      toast.error('Offer create failed! ', data?.errors);
    }
  } catch (error: any) {
    yield put(storeOfferFail(error.message));
  }
}

export function* updateOfferEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.put,
      `${apiURL}/edit-offer`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(updateOfferSuccess(data));

      toast.success('Offer updated successfully');
    } else {
      toast.error('Offer update failed! ', data?.errors);
    }
  } catch (error: any) {
    yield put(updateOfferFail(error.message));
  }
}

export function* storeAssignProductEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/assign-offer`,
      action?.payload
    );
    if (data?.succeeded) {
      yield put(storeAssignProductSuccess(data));
      yield call(loadProductEffect, {
        payload: action.payload?.itemId,
        type: '',
      });
      toast.success('Offer assigned successfully');
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(storeAssignProductFail(error.message));
  }
}

export function* removeOfferEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/remove-offer-from-item?ItemId=${action.payload.id}&OfferId=${action.payload?.offerId}`
    );
    if (data?.succeeded) {
      yield put(removeOfferSuccess(data));

      yield call(loadProductEffect, {
        payload: action.payload.id,
        type: '',
      });
      toast.success('Offer Removed successfully');
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(removeOfferFail(error.message));
  }
}

export function* offersSaga(): Generator<any, void, any> {
  yield takeEvery(loadOffersRequested, loadOffersEffect);
  yield takeEvery(loadNonPaginatedOfferRequested, loadNonPaginatedOffersEffect);
  yield takeEvery(storeOfferRequested, storeOfferEffect);
  yield takeEvery(updateOfferRequested, updateOfferEffect);
  yield takeEvery(deleteOfferRequested, deleteOfferEffect);
  yield takeEvery(storeAssignProductRequested, storeAssignProductEffect);
  yield takeEvery(removeOfferRequested, removeOfferEffect);
}
